"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeCasePropertyNameResolver = void 0;
const snakeCasePropertyNameResolver = (contentType, element) => {
    return toSnakeCase(element);
};
exports.snakeCasePropertyNameResolver = snakeCasePropertyNameResolver;
function toSnakeCase(str) {
    const matches = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
    if (matches) {
        return matches.map((x) => x.toLowerCase()).join('_');
    }
    return str;
}
//# sourceMappingURL=snake-case-property-name-resolver.class.js.map